export var UnderlyingCondition;
(function (UnderlyingCondition) {
    UnderlyingCondition["HighBloodPressure"] = "hypertension";
    UnderlyingCondition["HeartCondition"] = "heart";
    UnderlyingCondition["Diabetes"] = "diabetes";
    UnderlyingCondition["LungsCondition"] = "lungs";
    UnderlyingCondition["Arrhythmia"] = "arrhythmia";
    UnderlyingCondition["BloodThinner"] = "bloodthinner";
    UnderlyingCondition["Insulin"] = "insulin";
    UnderlyingCondition["Pregnancy"] = "pregnancy";
})(UnderlyingCondition || (UnderlyingCondition = {}));
const FOR_HUMANS = {
    [UnderlyingCondition.HighBloodPressure]: "highBloodPressure",
    [UnderlyingCondition.HeartCondition]: "heartDisease",
    [UnderlyingCondition.Diabetes]: "diabetes",
    [UnderlyingCondition.LungsCondition]: "asthma",
    [UnderlyingCondition.Arrhythmia]: "arrhythmia",
    [UnderlyingCondition.Insulin]: "useInsulin",
    [UnderlyingCondition.BloodThinner]: "useBloodThinner",
    [UnderlyingCondition.Pregnancy]: "pregnant",
};
const FOR_HUMANS_DOCTOR = {
    [UnderlyingCondition.HighBloodPressure]: "Magas vérnyomás",
    [UnderlyingCondition.HeartCondition]: "Szívbetegség, mellkasi fájdalom",
    [UnderlyingCondition.Diabetes]: "Cukorbetegség",
    [UnderlyingCondition.LungsCondition]: "Asztma, tüdőbetegség",
    [UnderlyingCondition.Arrhythmia]: "Szívritmuszavar",
    [UnderlyingCondition.Insulin]: "Inzulint használ",
    [UnderlyingCondition.BloodThinner]: "Vérhígítót használ",
    [UnderlyingCondition.Pregnancy]: "Várandós",
};
export const isIllness = (underlying) => underlying !== UnderlyingCondition.BloodThinner &&
    underlying !== UnderlyingCondition.Insulin &&
    underlying !== UnderlyingCondition.Pregnancy;
export const isNotIllness = (underlying) => underlying === UnderlyingCondition.BloodThinner;
export const getUnderlyingConditionChoices = (selected, isDoctor = false) => Object.values(UnderlyingCondition)
    .map((underlying) => ({
    key: underlying,
    text: isDoctor
        ? FOR_HUMANS_DOCTOR[underlying]
        : FOR_HUMANS[underlying],
    isSelected: !!(selected === null || selected === void 0 ? void 0 : selected.includes(underlying)),
}))
    .sort(({ text: a }, { text: b }) => a.localeCompare(b));
export const underlyingForHumans = (condition) => FOR_HUMANS[condition];
export const underlyingForHumansDoctor = (condition) => FOR_HUMANS_DOCTOR[condition];
